<template>
  <v-card flat class="pa-4">
    <h3 class="mb-1">Visitas al Blog</h3>
    <p class="caption grey--text mb-3">Registro detallado de visitas únicas diarias.</p>

    <!-- Buscador -->
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <v-text-field v-model="busqueda" label="Buscar por IP, país, ciudad, navegador..."
          outlined dense hide-details prepend-inner-icon="mdi-magnify" clearable
          @keyup.enter="cargarVisitas(1)" @click:clear="busqueda = ''; cargarVisitas(1)">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="teal" dark @click="cargarVisitas(1)">
          <v-icon left>mdi-magnify</v-icon> Buscar
        </v-btn>
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <v-chip color="teal" dark>
          <v-icon left small>mdi-eye</v-icon>
          Total: {{ total }}
        </v-chip>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-simple-table v-if="visitas.length" fixed-header dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>IP</th>
            <th>País</th>
            <th>Ciudad</th>
            <th>Navegador</th>
            <th>Plataforma</th>
            <th>Idioma</th>
            <th>Referer</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in visitas" :key="v.id">
            <td>{{ (currentPage - 1) * perPage + i + 1 }}</td>
            <td class="caption">{{ formatDate(v.fecha) }}</td>
            <td class="caption">{{ v.ip }}</td>
            <td>{{ v.pais || '—' }}</td>
            <td>{{ v.ciudad || '—' }}</td>
            <td class="caption">{{ v.navegador || '—' }}</td>
            <td class="caption">{{ v.plataforma || '—' }}</td>
            <td class="caption">{{ v.idioma || '—' }}</td>
            <td class="caption" style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ v.referer || '—' }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-alert v-else-if="!loading" type="info" text dense>
      No hay visitas registradas.
    </v-alert>

    <!-- Loading -->
    <div v-if="loading" class="text-center pa-4">
      <v-progress-circular indeterminate color="teal"></v-progress-circular>
    </div>

    <!-- Paginación -->
    <v-pagination v-if="lastPage > 1" v-model="currentPage" :length="lastPage"
      class="mt-3" @input="cargarVisitas"></v-pagination>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumVisitsAdmin',
  data() {
    return {
      visitas: [],
      loading: false,
      busqueda: '',
      currentPage: 1,
      lastPage: 1,
      perPage: 30,
      total: 0,
    };
  },
  mounted() {
    this.cargarVisitas(1);
  },
  methods: {
    cargarVisitas(page) {
      this.currentPage = page || this.currentPage;
      this.loading = true;
      const params = { page: this.currentPage };
      if (this.busqueda) params.search = this.busqueda;

      forumService.listarVisitasAdmin(params).then(res => {
        this.visitas = res.data.data || [];
        this.currentPage = res.data.current_page || 1;
        this.lastPage = res.data.last_page || 1;
        this.total = res.data.total || 0;
        this.perPage = res.data.per_page || 30;
      }).catch(() => {
        this.visitas = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
  }
};
</script>
